export default __webpack_public_path__ + "static/media/right-bottom-vinho.9d9487dd.png";